export default __webpack_public_path__ + "img/loan.e5ad3ac2.png";